import { Fragment, useEffect, useRef, useState } from 'react';
import { Col, Collapse, Row } from 'react-bootstrap';
import css from './pontoVenda.module.css';
import * as api from '../../../../api/apiEmpresa';

import {
  tratarIframe,
  tratarMorada,
  tratarhorario,
  tratarLink,
  TrackEvent,
} from '../../../helpers/tratarInfoEmpresa';

import direcoes from '../../../../assets/icons/btn/icon_direcoes.svg';
import { ReactComponent as Telemovel } from '../../../../assets/icons/redes/telemovel.svg';
import { ReactComponent as Telefone } from '../../../../assets/icons/redes/telefone.svg';
import { ReactComponent as Email } from '../../../../assets/icons/redes/email.svg';
import { ReactComponent as Local } from '../../../../assets/icons/redes/local.svg';
import { ReactComponent as Arrow } from '../../../../assets/icons/arrow/seta_dir.svg';
import { ReactComponent as Relogio } from '../../../../assets/icons/redes/relogio.svg';
import { ReactComponent as Aviso } from '../../../../assets/icons/redes/aviso.svg';
import mapa from '../../../../assets/img/mapa/gmaps1.webp';
import mapa_dark from '../../../../assets/img/mapa/gmaps2.webp';
import { useInView } from 'react-intersection-observer';

export default function PontoVenda({ item, infoJson, index, pontosVenda }) {
  const morada = tratarMorada(item.Rua, item.Cp4, item.Cp3, item.Localidade);
  const iframe = tratarIframe(item.EmbedGoogle);
  const map = useRef();
  const { ref, inView } = useInView({
    /* Optional options */
    threshold: 0,
    triggerOnce: true,
  });

  const [horarios, setHorarios] = useState([]);
  const [abertura, setAbertura] = useState([]);
  const [show, setShow] = useState(false);

  const handleShow = () => setShow(!show);

  useEffect(() => {
    const getHorarios = async () => {
      const horariosEmpresa = await api.getHorarios(item.CodPontoVenda, item.Concelho, infoJson);
      const abertura = tratarhorario(horariosEmpresa);

      horariosEmpresa && setHorarios(horariosEmpresa);
      abertura && setAbertura(abertura);
    };
    getHorarios();
  }, [item, infoJson]);

  const renderColor = param => {
    switch (param) {
      case 1:
        return '#81c995';
      case 2:
        return '#D93025';
      case 3:
        return '#B06000';
      default:
        return 'initial';
    }
  };

  useEffect(() => {
    if (inView && iframe !== '' && iframe !== undefined) {
      const frm = document.createElement('iframe');
      frm.src = iframe;
      frm.setAttribute('data-testid', 'iframe-mapa');
      frm.title = 'mapa';
      frm.className = `${css.iframeMap}`;
      frm.style.cssText = 'border: 0 ';
      frm.loading = 'lazy';
      map.current.appendChild(frm);
    }
  }, [inView, iframe]);

  return (
    <>
      <Col xs={12} className={`${css.rectangleBox} `} md={pontosVenda.length !== 1 ? 6 : 12}>
        <Row className={`${css.rectangle} rectangle-pontosVendas `}>
          <Col
            data-testid="mapa"
            className={`p-0 position-relative ${css.bg} `}
            style={{
              backgroundImage: `url(${infoJson.Layout.ThemeDark ? mapa_dark : mapa})`,
            }}
            ref={inView ? map : ref}
          ></Col>
          <Col className={`${css.box}`}>
            {item.Nome && (
              <Col xs={12} className={`${css.titulo} mb-3`}>
                {item.Nome}
              </Col>
            )}
            <Col xs={12} className={css.info} />
            {morada && (
              <Col xs={12} className={`d-flex  mb-3`}>
                <div className={css.boxIcon}>
                  <Local stroke={infoJson.Cores.Principal} />
                </div>
                <div className={css.info} dangerouslySetInnerHTML={{ __html: morada }} />
              </Col>
            )}
            {item.Telefone && (
              <Col xs={12} className={`d-flex  mb-3`}>
                <div className={css.boxIcon}>
                  <Telefone stroke={infoJson.Cores.Principal} />
                </div>
                <div className={css.info}>
                  <a
                    href={tratarLink(item.Telefone, 'Telefone')}
                    aria-label={`Telefone`}
                    onClick={() =>
                      TrackEvent('Contacto por Telefone', 'Clicked', 'Ponto de Venda ' + item.Nome)
                    }
                  >
                    {item.Telefone}
                  </a>{' '}
                  {item.CustoChamadaTelefone && <span> ({item.CustoChamadaTelefone})</span>}
                </div>
              </Col>
            )}

            {item.Telemovel && (
              <Col xs={12} className={`d-flex  mb-3`}>
                <div className={css.boxIcon}>
                  <Telemovel stroke={infoJson.Cores.Principal} />
                </div>
                <div className={css.info}>
                  <a
                    href={tratarLink(item.Telemovel, 'Telemovel')}
                    aria-label={`Telemovel`}
                    onClick={() =>
                      TrackEvent('Contacto por Telemovel', 'Clicked', 'Ponto de Venda ' + item.Nome)
                    }
                  >
                    {item.Telemovel}
                  </a>{' '}
                  {item.CustoChamadaTelemovel && <span> ({item.CustoChamadaTelemovel})</span>}
                  {item.Telemovel2 && (
                    <>
                      <a
                        href={tratarLink(item.Telemovel2, 'Telemovel')}
                        aria-label={`Telemovel2`}
                        onClick={() =>
                          TrackEvent(
                            'Contacto por Telemovel',
                            'Clicked',
                            'Ponto de Venda ' + item.Nome,
                          )
                        }
                      >
                        {item.Telemovel2}
                      </a>{' '}
                      {item.CustoChamadaTelemovel2 && <span> ({item.CustoChamadaTelemovel2})</span>}
                    </>
                  )}
                  {item.Telemovel3 && (
                    <>
                      <a
                        href={tratarLink(item.Telemovel3, 'Telemovel')}
                        aria-label={`Telemovel3`}
                        onClick={() =>
                          TrackEvent(
                            'Contacto por Telemovel',
                            'Clicked',
                            'Ponto de Venda ' + item.Nome,
                          )
                        }
                      >
                        {item.Telemovel3}
                      </a>{' '}
                      {item.CustoChamadaTelemovel3 && <span> ({item.CustoChamadaTelemovel3})</span>}
                    </>
                  )}
                </div>
              </Col>
            )}

            {item.Email && (
              <Col xs={12} className={`d-flex  mb-3`}>
                <div className={css.boxIcon}>
                  <Email stroke={infoJson.Cores.Principal} />
                </div>
                <div className={css.info}>
                  <a
                    href={tratarLink(item.Email, 'Email')}
                    aria-label={`Email`}
                    onClick={() =>
                      TrackEvent('Contacto por Email', 'Clicked', 'Ponto de Venda ' + item.Nome)
                    }
                  >
                    {item.Email}
                  </a>
                </div>
              </Col>
            )}
            {abertura.length !== 0 &&
              horarios.length !== 0 &&
              horarios.filter(item => item.IsOpen === false && item.Appointment === false)
                .length !== 7 && (
                <>
                  <Col xs={12} className={`d-flex  mb-3`}>
                    <div className={css.boxIcon}>
                      <Relogio stroke={infoJson.Cores.Principal} />
                    </div>
                    <div className={css.info}>
                      <div
                        className="d-flex align-items-center"
                        style={{ color: renderColor(abertura.tipo) }}
                      >
                        {abertura.name}{' '}
                        <Aviso className="ms-2" stroke={renderColor(abertura.tipo)} />
                      </div>
                      <div className={css.horario}>
                        <b
                          onClick={handleShow}
                          aria-controls={`horario${index}`}
                          aria-expanded={show}
                        >
                          Hoje -{' '}
                          {horarios[0].IsOpen ? (
                            <>
                              {horarios[0].Desc.replace('-', ' às ')
                                .replace(',', ' e das ')
                                .replace('-', ' às ')}
                            </>
                          ) : (
                            <>
                              {!horarios[0].IsOpen && horarios[0].Appointment ? (
                                <>Por marcação</>
                              ) : (
                                <>Fechado</>
                              )}
                            </>
                          )}
                          <Arrow className={css.horarioSvg} stroke={infoJson.Cores.Principal} />
                        </b>
                      </div>
                      <Collapse in={show}>
                        <div className={css.horario}>
                          {horarios.map((item, index) => {
                            return (
                              <Fragment key={index}>
                                {index !== 0 && (
                                  <div>
                                    {item.Day} -{' '}
                                    {item.IsOpen ? (
                                      <>
                                        {item.Desc.replace('-', ' às ')
                                          .replace(',', ' e das ')
                                          .replace('-', ' às ')}
                                      </>
                                    ) : (
                                      <>
                                        {item.Appointment && !item.IsOpen ? (
                                          <>Por marcação</>
                                        ) : (
                                          <>Fechado</>
                                        )}
                                      </>
                                    )}
                                  </div>
                                )}
                              </Fragment>
                            );
                          })}
                        </div>
                      </Collapse>
                    </div>
                  </Col>
                </>
              )}
            {item.LinkGoogle !== '' && (
              <a
                href={item.LinkGoogle}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`Obter direções`}
              >
                <Col xs={12} className={`d-flex align-items-center `}>
                  <button className={`btnPesquisa ${css.btnDireccoes}`}>
                    <img src={direcoes} alt={'Obter direções' + item.Nome} />
                    Obter direções
                  </button>
                </Col>
              </a>
            )}
          </Col>
        </Row>
      </Col>
    </>
  );
}
